module.exports = __webpack_public_path__ + "img/select.d75a63bf.png";